import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { PublicFeedBackDialogComponent } from '../../dialogs/public-feedback-dialog/public-feedback-dialog.component';
import { SaveFeedBackDialogComponent } from '../../dialogs/save-feedback-dialog/save-feedback-dialog.component';
import { ShareSimulationDialogComponent } from '../../dialogs/share-simulation-dialog/share-simulation-dialog.component';
import { StopSmulationDialogComponent } from '../../dialogs/stop-simulation-dialog/stop-simulation-dialog.component';
import { ToastSuccessfullyComponent } from '../../toast/toast-successfully.component';
import html2canvas from 'html2canvas';
import { ShareSimulationService } from '../../services/share-simulation.service';
import jsPDF from 'jspdf';
import { calculateDurationFromStartToNow, calculateDurationEnded } from 'src/app/modules/utils/duration-date';

enum SIMULATION_STATUS {
    NOT_STARTED = 1,
    RUNNING = 2,
    ENDED = 3,
}

@Component({
    selector: 'app-simulation-started-siderbar-top',
    templateUrl: './simulation-started-siderbar-top.component.html',
    styleUrls: ['./simulation-started-siderbar-top.component.scss'],
})
export class SimulationStartedSideBarTopComponent implements OnInit, OnDestroy {
    public get simulationStatus(): typeof SIMULATION_STATUS {
        return SIMULATION_STATUS;
    }

    @Input() data: any;
    @Input() feedback?: any;
    @Input() createdBy?: any;
    @Output() actionEvent = new EventEmitter<string>();
    @Output() deleteTempFeedback = new EventEmitter<string>();

    duration: any = '00:00';
    interval: any;
    action: any;
    status: number;
    isPublish: boolean = false;
    dataModel: any;
    hiddenShare: boolean = true;
    constructor(
        public dialog: MatDialog,
        private activeRoute: ActivatedRoute,
        private router: Router,
        private _snackBar: MatSnackBar,
        private translate: TranslateService,
        private shareServiver: ShareSimulationService,
    ) {}

    ngOnInit() {
        this.activeRoute.queryParams.subscribe(params => {
            this.action = params.action;
        });
    }

    ngOnChanges() {
        if (this.router.url.indexOf('action') === -1) {
            this.hiddenShare = false;
        } else {
            this.hiddenShare = true;
        }
        if (this.data) {
            this.dataModel = this.data;
            this.status = this.data?.status;
            this.isPublish = this.data?.isPublish ?? false;
            const startDate = moment(this.data?.startAtTime);
            const endDate = moment(this.data?.endDate);
            if (this.status == SIMULATION_STATUS.RUNNING) {
                this.interval = setInterval(() => {
                    this.duration = calculateDurationFromStartToNow(this.data?.startAtTime);
                }, 500);
            } else if (this.status == SIMULATION_STATUS.ENDED) {
                this.duration = calculateDurationEnded(startDate, endDate);
                if (this.interval) {
                    clearInterval(this.interval);
                }
            }
        }
    }

    ngOnDestroy(): void {
        clearInterval(this.interval);
    }

    openStopSimulationForm(data: any) {
        this.dialog.open(StopSmulationDialogComponent, {
            data: {
                id: data?.id,
            },
            width: '470px',
            height: '261px',
            position: {
                top: '78px',
            },
            panelClass: 'position-relative',
        });
    }

    openShareSimulationeForm() {
        this.dialog.open(ShareSimulationDialogComponent, {
            width: '470px',
            height: '392px',
            position: {
                top: '188px',
            },
            panelClass: ['position-relative', 'xs-mobile-90'],
        });
    }

    openPublicSimulationeForm() {
        this.dialog.open(PublicFeedBackDialogComponent, {
            data: this.data,

            width: '470px',
            height: '330px',
            position: {
                top: '188px',
            },
            panelClass: ['position-relative', 'xs-mobile-90'],
        });
    }

    openEditSimulationStartedForm() {
        this.router.navigateByUrl(`/simulation-started?simulationId=${this.data?.id}&action=edit`);
        this.actionEvent.emit('edit');
    }

    openSaveSimulationStartedForm() {
        let modal = this.dialog.open(SaveFeedBackDialogComponent, {
            data: {
                id: this.data.id,
                feedback: this.feedback,
            },
            width: '470px',
            height: '330px',
            position: {
                top: '188px',
            },
            panelClass: ['position-relative', 'xs-mobile-90'],
        });
        modal.afterClosed().subscribe(data => {
            if (data === 'success') {
                this._snackBar.openFromComponent(ToastSuccessfullyComponent, {
                    duration: 3000,
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    panelClass: ['successfully-snackbar', 'd-flex', 'align-items-center'],
                    data: {
                        status: 'successfully',
                        text: this.translate.instant('SimulationEditFeedback.EditFeedbackSuccessfully'),
                    },
                });

                this.deleteTempFeedback.emit('success');
                this.router.navigateByUrl(`/simulation-started?simulationId=${this.data?.id}`);
                this.actionEvent.emit('save');
            }
        });
    }

    openLeaveSimulationForm() {
        if (this.router) {
            if (this.createdBy == this.dataModel?.createdBy || this.createdBy != '') {
                this.router.navigateByUrl(`/simulations`);
            } else {
                this.router.navigateByUrl(`/participant/verify/${this.data?.id}?code=${this.data.loginCode}`);
            }
        }
    }
    copyInviteLink() {
        navigator.clipboard.writeText(this.data.link);
        this._snackBar.open(this.translate.instant('CopySuccess'), 'x', {
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['copy-successfully-snackbar'],
            duration: 3000,
        });
    }
    downloadHistory() {
        this.shareServiver
            .share(
                this.router.url.includes('&')
                    ? +this.router.url.split('=')[1].split('&')[0]
                    : +this.router.url.split('=')[1],
            )
            .subscribe(async res => {
                let html = res.parameters.contentHtml;
                const parser = new DOMParser();
                const document123 = parser.parseFromString(html, 'text/html');
                const div = document.createElement('div');
                div.setAttribute('id', 'pdf-image');
                div.appendChild(document123.body);
                document.body.prepend(div);
                html2canvas(document.getElementById('pdf-image')?.firstChild as any).then(async canvas => {
                    let fileWidth = 208;
                    let fileHeight = (canvas.height * fileWidth) / canvas.width;
                    const FILEURI = canvas.toDataURL('image/png');
                    let PDF = new jsPDF('p', 'mm', 'a4');
                    let position = 0;
                    PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight, undefined, 'FAST');
                    PDF.save(
                        `${
                            this.router.url.includes('&')
                                ? this.router.url.split('=')[1].split('&')[0]
                                : this.router.url.split('=')[1]
                        }.pdf`,
                    );
                    document.body.removeChild(div);
                });
            });
    }
}
